import { QuestionProps } from "../models/question";
import { TaskProps } from "../models/task";

export const getTaskProgress = (tasks: TaskProps[], setQuestionStatus) => {
    return tasks.map((t: TaskProps) => {
        let questionAnswers;
        let areAllQuestionsDone = false
        let questions = t?.questions
        if (questions?.length) {
            questions = questions.map((q: QuestionProps) => setQuestionStatus(q))
            questionAnswers = questions.filter(
                (q: QuestionProps) => q.status === 'completed'
            ).length
            areAllQuestionsDone = questionAnswers === questions.length
        }
        return {
            ...t,
            status: areAllQuestionsDone ? 'completed' : '',
            progress: questionAnswers ? (questionAnswers / questions.length) * 100 : 0
        }
    })
}